import { Deserializable } from "../shared/models/deserializable.model";

export class AccountFile implements Deserializable {
  id: number;
  fileName: string;
  url: string;
  userId: number;
  accountId: number;
  bucket: string;
  mimetype: string;
  binary?: string; // This will store either a data URL or a blob URL
  lastModified?: number; // Timestamp of when the file was last modified

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
} 